exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#bgDiv {\n  background: #0098EB;\n}\n#bgDiv img {\n  width: 100%;\n  margin-top: -5px;\n}\n#bgDiv .relative-view {\n  width: 100%;\n  display: inline-block;\n  position: relative;\n}\n#bgDiv .absolute-view {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  bottom: 0;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n#bgDiv .download-btn {\n  width: 220px;\n  height: 48px;\n}\n#bgDiv .download-link {\n  margin-top: auto;\n  margin-bottom: 20px;\n}\n#bgDiv .qrcode {\n  margin-top: auto;\n  margin-bottom: 40px;\n  width: 156px;\n  height: 156px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js?{"modifyVars":{"@brand-primary":"#1DA57A","@primary-button-fill":"#1DA295"}}!./src/staticPage/carAuthorization/index.less
// module id = 325
// module chunks = 0